import type { Goal } from "@/db/schema/profile";

export const PROFILE_GOAL_LABELS: Record<Goal, string> = {
  fitness: "Fitness",
  social: "Social",
  ranked: "Ranked",
  recreation: "Recreation",
};

export const PROFILE_GOAL_OPTIONS = [
  {
    value: "fitness",
    label: PROFILE_GOAL_LABELS.fitness,
    description: "Stay healthy and get in shape",
  },
  {
    value: "social",
    label: PROFILE_GOAL_LABELS.social,
    description: "Meet new people and make friends",
  },
  {
    value: "ranked",
    label: PROFILE_GOAL_LABELS.ranked,
    description: "Compete in organized tournaments",
  },
  {
    value: "recreation",
    label: PROFILE_GOAL_LABELS.recreation,
    description: "Play for fun and keep it casual",
  },
] as const satisfies ReadonlyArray<{
  value: Goal;
  label: string;
  description: string;
}>;
